module.exports = __webpack_public_path__ + "img/244.3e2f1990.jpg";